import { types } from '../../../types/types';

export const reducerValidaLogin = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.CREDENCIAMENTO.LOGINVALIDA:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}